import menuBg from 'ASSETS/img/menu/menu_bg_bxc.jpg';

export const bxc = {
  btnColor: {
    c0002: '#7B1111',
    c0003: '#911414',
    c0023: '#edf0f0',
    c0024: '#E12525',
    c0025: '#BB1A1A',
    // 原color下没有，新添加c004开头
    c0041: '#7B1111',
  },
  chartColor: {
    c0001: '#3a3a3a', //x轴字体颜色
    c0002: '#9f9f9f', //y轴字体颜色
    c0003: '#3C424820', //区域横线的颜色 , //
    c0004: '#670E0E', //['#670E0E', '#7B1111', '#911414', '#BB1A1A', '#E12525'], //饼图的颜色列表
    c0005: '#7B1111', //['#7B1111', '#911414', '#BB1A1A', '#E12525'], //柱状图的颜色列表
    c0006: '#911414',
    c0007: '#BB1A1A',
    c0008: '#E12525',
    c0009: '#670E0E', //['#670E0E', '#911414', '#E12525'], //折线图的颜色列表
    c0010: '#911414',
    c0011: '#E12525',
    c0012: '#BB1A1A',
    c0013: '#670E0E',
    c0014: '#7B1111',
    c0015: '#911414',
    c0016: '#BB1A1A',
    c0017: '#E12525',
    c0018: '#E75151',
    c0019: '#ED7C7C',
    c0020: '#8F2E2C',
    c0021: 'rgba(230,107,26,1)',
    c0022: 'rgba(159,92,187, 0.99)',
    c0023: 'rgba(50,107,208, 0.99)',
    c0024: 'rgba(168, 32, 37, 1)',
    c0025: 'rgba(243, 119, 116, 1)',
    c0026: 'rgba(238, 86, 82, 1)',
    c0027: 'rgba(245,169,43,1)',
    c0028: 'rgba(56,124,185,0.99)',
  },
  chartBoxColor: {
    c0029: 'rgba(242, 242, 242, 1)',
    c0001: '#7B1111',
    c0002: '#818181',
  },
  inpColor: {
    c0014: '#3a3a3a',
    c0015: '#737373',
    c0023: '#edf0f0',
    c0024: '#E12525',
    c0026: '#edf0f0',
    transparent: 'transparent',
  },
  selecColor: {
    c0014: '#3a3a3a',
    c0015: '#737373',
    c0023: '#edf0f0',
    c0024: '#E12525',
    c0026: '#edf0f0',
    c0006: '#E1FFFF',
    c0007: '#c0c3c7',
    c0008: '#d9d9d9',
    transparent: 'transparent',
  },
  tblColor: {
    c0023: '#edf0f0',
    c0025: '#BB1A1A',
    c0007: '#7B1111',
    c0005: '#911414',
    c0027: '#E12525',
    c0028: 'rgba(183,25,1,0.2)',
    ac0027: '#DFF1FA',
    // 自定义 base color下原来没有 以c004起头
    c0040: '#eff1f5',
  },
  tabColor: {
    c0023: '#edf0f0',
    c0014: '#3a3a3a',
    c0002: '#7B1111',
  },
  chkColor: {
    c0007: '#b71901',
  },
  layoutColor: {
    c0017: '#670E0E',
    c0018: '#b43c43',
    c0019: 'rgb(255,255,255,0.36)',
    c0020: 'rgb(255,255,255,0.65)',
    c0021: 'rgb(55,7,1,0.4)',
    c0022: '#d9d9d9',
    c0030: '#911414',
    c0007: '#7B1111',
  },
  timeLineColor: {
    c0005: '#E12525',
    c0017: '#BB1A1A',
    c0003: '#911414',
  },
  switchColor: {
    c0025: '#BB1A1A',
  },
  modalColor: {
    c0002: '#7B1111',
  },
  datePickerColor: {
    c0001: '#3a3a3a',
    c0002: '#737373',
    c0003: '#edf0f0',
    c0004: '#E12525',
    c0005: '#c0c3c7',
    c0006: '#E1FFFF',
    c0007: '#d9d9d9',
    transparent: 'transparent',
  },
  //级联菜单样式
  cascaderColor: {
    c0001: '#3a3a3a',
    c0002: '#737373',
    c0003: '#edf0f0',
    c0004: '#E12525',
    c0005: '#c0c3c7',
    c0006: '#E1FFFF',
    c0007: '#d9d9d9',
    transparent: 'transparent',
  },
  // 渐变色
  gradColor: {
    g0001: ['#670E0E', '#911414'],
  },

  // 需要随主题色改变而改变，且无法归入共通的部分样式
  others: {
    // 渐变色
    gradColor: {
      g0001: ['#fc000b', '#9f0001'],
    },
    // 背景图片
    imgs: {
      bg0001: menuBg,
    },
    fontColor: {
      c0001: '#3a3a3a', //head的标题颜色
      c0012: '#9f9f9f',
      c0004: '#eb9f9c', //百分比大于0的颜色
      c0011: '#009dbf', //百分比小于于0的颜色
      g0001: ['#7B1111', '#E12525'], // 概览页会员文字渐变色
      g0002: ['#333333', '#666666'], // 概览页会员文字渐变色
    },
  },
};
